import { render, staticRenderFns } from "./DetailBanner.vue?vue&type=template&id=388062b1&scoped=true&"
import script from "./DetailBanner.vue?vue&type=script&lang=js&"
export * from "./DetailBanner.vue?vue&type=script&lang=js&"
import style0 from "./DetailBanner.vue?vue&type=style&index=0&id=388062b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388062b1",
  null
  
)

export default component.exports